import { render, staticRenderFns } from "./StoragePO.vue?vue&type=template&id=24227203&scoped=true&"
import script from "./StoragePO.vue?vue&type=script&lang=js&"
export * from "./StoragePO.vue?vue&type=script&lang=js&"
import style0 from "./StoragePO.vue?vue&type=style&index=0&id=24227203&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24227203",
  null
  
)

export default component.exports